// Shared boolean modal open/close state for Contact (includes embedded feedback form).

import React, { createContext, useCallback, useContext, useState } from 'react';

function createModalDisclosureContext(hookErrorMessage) {
  const Ctx = createContext(null);

  function Provider({ children }) {
    const [isOpen, setIsOpen] = useState(false);
    /** @type {'support' | 'sales'} */
    const [variant, setVariant] = useState('support');
    const openModal = useCallback(() => {
      setVariant('support');
      setIsOpen(true);
    }, []);
    const openContactSalesModal = useCallback(() => {
      setVariant('sales');
      setIsOpen(true);
    }, []);
    const closeModal = useCallback(() => setIsOpen(false), []);
    return (
      <Ctx.Provider
        value={{ isOpen, variant, openModal, openContactSalesModal, closeModal }}
      >
        {children}
      </Ctx.Provider>
    );
  }

  function useModal() {
    const ctx = useContext(Ctx);
    if (!ctx) {
      throw new Error(hookErrorMessage);
    }
    return ctx;
  }

  return { Provider, useModal };
}

export const {
  Provider: ContactModalProvider,
  useModal: useContactModal,
} = createModalDisclosureContext('useContactModal must be used within ContactModalProvider');
